



























































import Modal from '@/components/Modal/Modal.vue'
import ModalContent from '@/components/Modal/ModalContent.vue'
import ModalHeader from '@/components/Modal/ModalHeader.vue'
import ModalFooter from '@/components/Modal/ModalFooter.vue'
import StageNav from '@/components/AddTest/StageNav.vue'
import AjaxButton from '@/components/AjaxButton.vue'
import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { TemplateValue } from '@shared/types/database'
import store from '@/store'
import { Button } from '@alpha/ink'
import { TemplateSubmissionPayload } from '@/utilities/template-helpers'
import { Location } from '@/components/Templates/TemplateManager.vue'
import AddTestClassic from '@/components/AddTest/AddTestClassic.vue'
import ClassicListItem from '@/components/AddTest/ClassicListItem.vue'
import classicTestTypes, { ClassicTestType } from '@/utilities/classic-test-types'
import * as db from '@shared/types/database'
import ConfirmExitPopup from '@/components/TestDetails/DefaultTestCreation/ConfirmExitPopup.vue'
import Overlay from '@/components/Overlay.vue'
import { camelCaseTitle } from '@/utilities/v-track-directive'

@Component({
  components: {
    AddTestClassic,
    ClassicListItem,
    Modal,
    StageNav,
    AjaxButton,
    ModalContent,
    ConfirmExitPopup,
    ModalHeader,
    ModalFooter,
    Overlay,
    Button
  }
})
export default class ClassicTestContentModal extends Vue {
  @Prop({ required: true }) test!: db.Test
  @Prop({ required: true }) testId!: string
  @Prop({ required: true }) workspaceId!: string
  @Prop({ required: true }) projectId!: string

  @Ref('classic') readonly addTestClassicComponent!: AddTestClassic

  loading = false

  templateSubmissionPayload: TemplateSubmissionPayload | null = null
  initialValues: Record<string, TemplateValue> | null = null
  location = Location.DefaultDraftTestCreation
  selectedTestType: ClassicTestType | null = null
  cancelAlert = false

  mounted () {
    this.updateSelectedTestType()
  }

  updateSelectedTestType () {
    // We save test types as uppercase with spaces, but they are expected as all lowercase with dashes to match form name
    const testType = this.test.payload.testType.replace(/ /g, '-').toLowerCase()
    this.testTypes.forEach(type => {
      if (type.formName === testType) {
        this.selectedTestType = type
      }
    })
  }

  updateTemplate (templateUpdates: Pick<TemplateSubmissionPayload, 'renderedTemplate' | 'templateFieldValues'>) {
    this.templateSubmissionPayload = templateUpdates
  }

  get testTypes () {
    return classicTestTypes
  }

  selectClassicTestType (classicTestType: ClassicTestType) {
    this.selectedTestType = classicTestType
  }

  get workspaceProjects () {
    return store.getters.workspace.projects
  }

  triggerCancelAlert () {
    if (this.selectedTestType) {
      this.cancelAlert = true
    } else {
      this.close()
    }
  }

  save () {
    const result = this.addTestClassicComponent.submit(true, false)
    if (!result) {
      return
    }
    const { newInsight } = result

    // Pull out the values from "new insight" which is the name of the details for a classic test
    const testPayloadUpdate: Partial<db.TestPayload> = {
      formtype: this.selectedTestType!.formName,
      testType: this.selectedTestType!.name,
      // Clear out old values from other classic types
      description: newInsight.description ?? '',
      additional_info: newInsight.additional_info ?? '',
      prototypes: newInsight.prototypes ?? {},
      comparison_type: newInsight.comparison_type ?? '',
      customerQuestions: newInsight.title ?? ''
    }

    store.dispatch.workspace.updateTest({
      testId: this.testId,
      workspaceId: this.workspaceId,
      test: testPayloadUpdate
    })

    this.$emit('close')
  }

  close () {
    this.$emit('close')
  }

  trackingId (name: string) {
    return `addTest-pickClassic-${camelCaseTitle(name)}`
  }
}
